import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsComposerComponent } from './simple-icons-composer.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsComposerComponent ],
    exports:      [ SimpleIconsComposerComponent ],
    bootstrap:    []
})
export class SimpleIconsComposerModule {}
